export const INTERPUNCT = '·';
// Relocated to the shared constants module; re-exported here for backward compatibility.
export { DEFAULT_DATETIME_FORMAT } from '@s20/common/constants/momentFormats';